enum RobotFilterType {
  NONE = 'NONE',
  CURRENT_MONTH = 'CURRENT_MONTH',
  PAST_MONTH = 'PAST_MONTH',
}

export default RobotFilterType;
